import lang from '@/lang'
import offerStates from '@/enums/offer/offer-state.enum'

const getStateInfo = (state) => {
  switch (state) {
    case offerStates.OPEN:
      return lang.open
    case offerStates.ACCEPTED:
      return lang.accepted
    case offerStates.REJECTED:
      return lang.rejected
    case offerStates.INVOICED:
      return lang.invoiceCreated
    case offerStates.PROJECT_CREATED:
      return lang.projectCreatedFromOffer
    case offerStates.ORDER_CREATED:
      return lang.orderCreated
    default:
      return lang.open
  }
}

export default getStateInfo
